import { forwardRef, type Ref, type SVGProps } from "react";
const IconPauseCircleOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" /><path fill="currentColor" d="M13 22a1 1 0 0 1-1-1V11a1 1 0 0 1 2 0v10a1 1 0 0 1-1 1m6 0a1 1 0 0 1-1-1V11a1 1 0 0 1 2 0v10a1 1 0 0 1-1 1" /></svg>;
const ForwardRef = forwardRef(IconPauseCircleOutlineSVG);
ForwardRef.displayName = "IconPauseCircleOutline";
export { ForwardRef as IconPauseCircleOutline };